import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'is_the_facility_1'

export const dataPointDefinition = {
  retracedId: 'is_the_facility_1',
  name: "Is the facility's apprenticeship / training / internship program in line with all legal requirements?",
  description:
    'The intent of this question is to cover any applicable legal requirements to determine contractual, training and related requirements regarding apprentices, trainees, interns. Probationary periods / trial periods are covered separately, and should not be recorded here.',
  meta: {
    slcpMeta: {
      key: 'cl-5--11',
      number: 'RH-APP-3',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'cl-5--11', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26510,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
